// src/api/povinnostiApi.js

// Tu budú všetky API volania a operácie so serverom pre Povinnosti

export async function saveTasks(userPin, tasks) {
  try {
    const resp = await fetch(`/php/tasks_api.php?action=save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin: userPin, tasks })
    });
    if (!resp.ok) {
      const text = await resp.text();
      return { ok: false, error: `HTTP ${resp.status}: ${text.slice(0, 200)}` };
    }
    const data = await resp.json();
    if (data && data.error) return { ok: false, error: data.error };
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

export async function updateTask(userPin, task) {
  // Aktualizácia jedného tasku v databáze (bez prepisu celej tabuľky)
  try {
    const resp = await fetch(`/php/tasks_api.php?action=update_task`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin: userPin, task })
    });
    if (!resp.ok) throw new Error("Chyba aktualizácie úlohy");
    const data = await resp.json();
    if (data && data.error) throw new Error(data.error);
    return true;
  } catch (e) {
    return false;
  }
}

export async function loadTasks(userPin) {
  // Načítanie úloh zo servera cez PHP API (rovnaká logika ako predtým)
  try {
    const resp = await fetch(`/php/tasks_api.php?action=load&pin=${encodeURIComponent(userPin)}`);
    if (!resp.ok) throw new Error("Chyba načítania dát");
    const data = await resp.json();
    if (Array.isArray(data)) return data;
    if (data && data.error) throw new Error(data.error);
    return [];
  } catch (e) {
    return [];
  }
}

export async function uploadAttachment(taskId, file, userPin) {
  // ... sem príde fetch na upload prílohy ...
}

export async function deleteAttachment(taskId, attachmentId, userPin) {
  // ... sem príde fetch na zmazanie prílohy ...
}

// Pridaj ďalšie API funkcie podľa potreby
